/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateProfileShowPathParams, CandidateProfileShowResponse } from '../types/CandidateProfileShow'

/**
 * GET /candidates/:candidate/profile
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateProfileController.php CandidateProfileController::show
 */
export async function candidateProfileShow(
	candidate: CandidateProfileShowPathParams['candidate'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateProfileShowResponse>> {
	return axiosInstance.get(`/candidates/${candidate}/profile`, config)
}
